import * as tracking from 'dibs-tracking';
import { SimilarRecentlySoldItemsPriceRange } from './__generated__/PdpSharedRecentSales_item.graphql';

type PriceRange = SimilarRecentlySoldItemsPriceRange | null;

export function getPriceStatus(priceRange: PriceRange): string {
    switch (priceRange) {
        case 'OUT_OF_RANGE_LOW':
            return 'below min price';
        case 'BETWEEN_MIN_AND_LOW_AVG':
            return 'between min and low avg';
        case 'BETWEEN_LOW_AVG_AND_MEDIAN':
            return 'between low avg and median';
        case 'MEDIAN':
            return 'between low avg and median';
        case 'BETWEEN_MEDIAN_AND_HIGH_AVG':
            return 'between median and high avg';
        case 'BETWEEN_HIGH_AVG_AND_MAX':
            return 'between high avg and max';
        case 'OUT_OF_RANGE_HIGH':
            return 'above max price';
        default:
            return 'other';
    }
}

export function trackRecentSalesModuleView(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'recent sales module reached',
        label: `pdp - ${priceStatus}`,
        noninteraction: 1,
    });
}

export function trackRecentSalesModuleTooltipView(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'recent sales info icon clicked',
        label: `pdp - ${priceStatus}`,
        noninteraction: 0,
    });
}

export function trackRecentSalesModuleBrowseSimilarLinkClick(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'browse similar clicked',
        label: `pdp - ${priceStatus}`,
        noninteraction: 0,
    });
}
